// src/pages/FAQ.jsx
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

const FAQ = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Header />
      <section className="hero-section" id="hero-faq">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8" data-aos="fade-right">
              <h1>Preguntas Frecuentes</h1>
              <p className="mb-4">
                Aquí encontrarás respuestas a las dudas más comunes sobre Smart Money.
              </p>
            </div>
            <div className="col-lg-4" data-aos="fade-left">
              <img src="/assets/img/faq.png" alt="FAQ" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>
      <main id="main">
        <section className="section">
          <div className="container">
            <div className="accordion" id="faqAccordion">
              {/* Pregunta 1 */}
              <div className="accordion-item" data-aos="fade-up">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
                    ¿Cómo creo una cuenta en Smart Money?
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p>
                      Puedes registrarte haciendo clic en el botón "Regístrate" en la parte superior del sitio y completando el formulario de registro.
                    </p>
                    <p>
                      Una vez registrado, recibirás un correo de confirmación para activar tu cuenta y comenzar a realizar transacciones.
                    </p>
                  </div>
                </div>
              </div>
              {/* Pregunta 2 */}
              <div className="accordion-item" data-aos="fade-up" data-aos-delay="100">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
                    ¿Cuáles son las divisas disponibles para envío y recepción?
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p>
                      Smart Money permite enviar y recibir en USD, Euros, Bolívares (Bs), COP y otras. Es importante tener en cuenta que ciertos métodos, como Zelle, operan exclusivamente en USD.
                    </p>
                    <p>
                      Además, puedes consultar las tasas de cambio en tiempo real en nuestra sección "Tasas de Cambio".
                    </p>
                  </div>
                </div>
              </div>
              {/* Pregunta 3 */}
              <div className="accordion-item" data-aos="fade-up" data-aos-delay="200">
                <h2 className="accordion-header" id="headingThree">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
                    ¿Cómo realizo una transacción?
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p>
                      Para realizar una transacción, accede a la sección "Envios" donde podrás configurar el monto a enviar y seleccionar los métodos de pago de origen y destino.
                    </p>
                    <p>
                      El sistema calculará automáticamente el monto que recibirá el destinatario, aplicando la tasa de cambio actual y los descuentos correspondientes.
                    </p>
                  </div>
                </div>
              </div>
              {/* Pregunta 4 */}
              <div className="accordion-item" data-aos="fade-up" data-aos-delay="300">
                <h2 className="accordion-header" id="headingFour">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour">
                    ¿Cómo se actualizan las tasas de cambio?
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p>
                      Las tasas de cambio se actualizan en tiempo real utilizando datos provenientes de fuentes confiables. Además, se actualizan automáticamente en nuestra plataforma para asegurar que siempre tengas acceso a la información más reciente.
                    </p>
                  </div>
                </div>
              </div>
              {/* Pregunta 5 */}
              <div className="accordion-item" data-aos="fade-up" data-aos-delay="400">
                <h2 className="accordion-header" id="headingFive">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive">
                    ¿Qué medidas de seguridad tiene Smart Money?
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p>
                      Smart Money utiliza protocolos de seguridad de última generación para proteger tus datos y transacciones. La autenticación se realiza de forma segura y toda la información se transmite mediante conexiones encriptadas.
                    </p>
                    <p>
                      Además, la plataforma se encuentra en constante monitoreo para prevenir cualquier actividad sospechosa.
                    </p>
                  </div>
                </div>
              </div>
              {/* Pregunta 6 */}
              <div className="accordion-item" data-aos="fade-up" data-aos-delay="500">
                <h2 className="accordion-header" id="headingSix">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                    ¿Cómo puedo contactar al soporte de Smart Money?
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p>
                      Si tienes alguna duda o problema, puedes contactarnos a través de nuestro formulario de contacto, disponible en la sección "Contactanos". También puedes encontrar respuestas en la sección de preguntas frecuentes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default FAQ;
